import {request, serviceUrl} from "@/utils/request";

// 获取分页数据
export function getPueByTime() {
  return request({
    url: serviceUrl.emsService + '/pue/record/getPueByTime'
  })
}

// 获取分页数据
export function getRealTimePue(spaceId, tagCode) {
  // 创建一个仅包含有效值的参数对象
  const params = {};
  
  // 仅当参数有值时才添加到 params 对象
  if (spaceId !== undefined && spaceId !== null && spaceId !== '') {
    params.spaceId = spaceId;
  }
  
  if (tagCode !== undefined && tagCode !== null && tagCode !== '') {
    params.tagCode = tagCode;
  }
  
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/pue/record/getRealTimePue',
    params,  // 使用筛选后的参数对象
  })
}
// 获取上个月PUE实时值
export function getLastMonthPue(tagCode) {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/pue/history/getLastMonthPue',
    params: {tagCode},
  })
}

// pue趋势
export function getPueTrend(startTime, endTime, tagCode) {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/pue/record/analysis',
    params: {startTime, endTime, tagCode},
  })
}

// pue趋势 查上一年的历史数据
export function getYearTrend(tagCode) {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/pue/history/getYearTrend',
    params: {tagCode},
  })
}

// 实时功率
export function getRealTimePower() {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/realTime/power/getRealTimePower',
  })
}

// 能耗数据监测
export function getEnergyMonitoring() {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/record/screen/energy/monitor',
  })
}

//  获取能耗趋势
export function getEnergyTrend() {
  return request({
    method: 'get',
    url: serviceUrl.emsService + '/power/statistics/trend',
  })
}